// =============================================================================
// Admin console constants
// =============================================================================

/**
 * Time windows offered by the admin users list's "Signed up" (`since`, on
 * `createdAt`) and "Last active" (`active`, on `lastActiveAt`) filters, in
 * hours. The keys are the literal query-param values the server validates.
 */
export const ADMIN_USER_WINDOW_HOURS = {
  '24h': 24,
  '3d': 3 * 24,
  '7d': 7 * 24,
  '30d': 30 * 24,
} as const;

export type AdminUserWindow = keyof typeof ADMIN_USER_WINDOW_HOURS;

/** The window keys in display order, for selects and validators. */
export const ADMIN_USER_WINDOWS = Object.keys(
  ADMIN_USER_WINDOW_HOURS,
) as [AdminUserWindow, ...AdminUserWindow[]];
